import React from 'react'
import ReactPlayer from 'react-player'
import { Image, Box } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'
import CoachMark from 'src/ui/CoachMark/CoachMark'

import { placeholderImage } from './assets'

const SPOTLIGHT_SX = {
  // use `px`
  borderRadius: '8px',
}

const COACH_MARK_SX = {
  display: 'flex',
  flex: 1,
}

// TODO: replace privacyPlaceholder with real url
const LiveLessonImage = ({
  showPlaceholder,
  liveLessonReplayUrl,
  lessonThumbnail,
  isList,
}) => {
  return (
    <>
      {showPlaceholder ? (
        <Image src={placeholderImage} />
      ) : (
        <CoachMark
          name="coach_mark:review_live_lesson"
          title={t('Review your Lesson')}
          description={t(
            'Rewatch your Live Lessons, as well as other study materials in Achievements.'
          )}
          align="above"
          spotlightSx={SPOTLIGHT_SX}
          sx={COACH_MARK_SX}
        >
          {liveLessonReplayUrl ? (
            <Box
              bg="black"
              borderRadius={SPOTLIGHT_SX.borderRadius}
              overflow="hidden"
              width="100%"
              // a hacky way to prevent the video preview from jumping while loading
              // by setting it to the same size as the loaded video will be
              height={
                isList
                  ? '156px'
                  : { _: '239px', tablet: '250px', desktop: '345px' }
              }
            >
              <ReactPlayer
                controls
                url={liveLessonReplayUrl}
                width="100%"
                height="100%"
              />
            </Box>
          ) : (
            <Box width="100%" height="100%">
              <AspectRatioImage
                imgUrl={lessonThumbnail || placeholderImage}
                aspectRatio="16:9"
                borderRadius={SPOTLIGHT_SX.borderRadius}
              />
            </Box>
          )}
        </CoachMark>
      )}
    </>
  )
}

export default LiveLessonImage
